import React, { useMemo } from "react";

import DataTable from "components/DataTable";
import ExtendedPagination from "components/Pagination";
import InvoicePaymentMobileCard from "./InvoicePaymentMobileCard";

import { getInvoicePaymentsColumns } from "./columns";

import { IbanInvoicePayment } from "store/features/ibanInvoiceSlice";

import { ReactComponent as PaymentsEmptyIcon } from "assets/images/payments-empty-icon.svg";

interface InvoicePaymentsProps {
  loading?: boolean;
  payments: IbanInvoicePayment[] | null;
  pageCount: number;
  pageNumber: number;
  onPageChange: (page: number) => void;
  onStatusChange: (payment: IbanInvoicePayment, status: string) => void;
}

const InvoicePayments: React.FC<InvoicePaymentsProps> = ({
  loading,
  payments,
  pageCount,
  pageNumber,
  onPageChange,
  onStatusChange,
}) => {
  const columns = useMemo(
    () => getInvoicePaymentsColumns({ onStatusChange }),
    [onStatusChange],
  );

  return (
    <>
      <DataTable<IbanInvoicePayment>
        loading={loading}
        emptyIcon={<PaymentsEmptyIcon />}
        emptyMessage={`Ви ще не маєте жодного \nплатежу.`}
        columns={columns}
        rows={payments}
        mobileRenderer={(row) => (
          <InvoicePaymentMobileCard row={row} onStatusChange={onStatusChange} />
        )}
      />
      {pageCount && pageCount > 1 ? (
        <ExtendedPagination
          id="invoice-payments-pagination"
          pageCount={pageCount}
          pageNumber={pageNumber}
          onPageChange={onPageChange}
        />
      ) : null}
    </>
  );
};

export default InvoicePayments;
